export default "__VITE_ASSET__PrQ9xslT__"